import moment from 'moment';
import {useTranslation} from 'react-i18next';
import {EntityShift} from '../../../backend/interfaces/entity-shift';
import {EntityShiftAllocation} from '../../../backend/interfaces/entity-shift-allocation';
import {translations} from '../../../i18n/translations';
import {BaseShiftCard} from './base-shift-card';

export interface ShiftAllocation {
  shift: EntityShift;
  allocation: EntityShiftAllocation;
  isDayBefore: boolean;
}

interface ShiftCardProps {
  shiftAllocation: ShiftAllocation;
  onClick?: () => void;
}

export function ShiftCard({shiftAllocation, onClick}: ShiftCardProps) {
  const {t} = useTranslation();
  const {shift, isDayBefore} = shiftAllocation;

  return (
    <BaseShiftCard
      borderColor={shift.backgroundColor}
      startHour={moment(shift.startHour)}
      endHour={moment(shift.endHour)}
      preLabel={isDayBefore ? t(translations.daily_care_log.home.previous_days_shift) : undefined}
      label={`${shift.abbreviation} - ${shift.name}`}
      onClick={onClick}
    />
  );
}
